export default {
  cancel: "Cancelar",
  category: "Categoría",
  categories: "Categorias",
  date: "Fecha",
  Inventory: "Inventario",
  name: "Nombre",
  newCategories: "Nuevas categorías",
  newItem: "Nuevo artículo",
  newUnits: "Nuevas Unidades",
  quantity: "Cantidad",
  save: "Guardar",
  search: "Buscar",
  sku: "SKU",
  subtotal: "Total parcial",
  unit: "Unidad",
  units: "Unidades",
  unitValue: "Valor unitario",
  editItem: "Editar artículo",
  modulesbtn: "Módulos"
};
